
import { Suspense, lazy, useState } from 'react'
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
import { AuthPage } from '../modules/auth'
import Noticias from './public/noticias/index'
import InfoPublica from './public/informacionPublica'
import CIAR from './public/CIAR'
import QuienesSomos from './public/quienesSomos'
import Federaciones from './public/Federaciones'
import Contacto from './public/contacto'
import DiaOlimpico from './public/DiaOlimpico'
import MemoriaLabores from './public/MemoriaLabores'
import Redes from './public/Redes'
import { toAbsoluteUrl } from '../../_metronic/helpers'
import '../views/Landing/linaje-landing.css'

export function PublicRoutes() {
  const BuilderPageWrapper = lazy(() => import('../views/Landing/index'))
  const brandLogo = '/media/linaje/images/logo/linaje-logo-3.png'
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const history = useHistory()
  const location = useLocation()
  const isRedesSocialesRoute = location.pathname === '/redes-sociales'

  const scrollToSection = (id: string) => {
    const goToSection = () => {
      const target = document.getElementById(id)
      if (!target) return

      const header = document.querySelector('.linaje-public-header') as HTMLElement | null
      const offset = (header?.offsetHeight || 0) + 12
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset

      window.scrollTo({top, behavior: 'smooth'})
      setIsMobileMenuOpen(false)
    }

    if (location.pathname !== '/inicio') {
      history.push('/inicio')
      window.setTimeout(goToSection, 280)
      return
    }

    goToSection()
  }

  if (isRedesSocialesRoute) {
    return <Redes />
  }

  return (
    <Suspense fallback={<FallbackView />}>
      <div className='linaje-public-shell'>
        <header className='linaje-public-header'>
          <div className='linaje-public-header__inner'>
            <button
              type='button'
              className={`linaje-public-menu-toggle ${isMobileMenuOpen ? 'is-open' : ''}`}
              aria-label='Abrir menu'
              aria-expanded={isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen((prev) => !prev)}
            >
              <span />
              <span />
              <span />
            </button>
            <a href='/inicio' className='linaje-brand' aria-label='Iglesia Linaje de David'>
              <img
                src={toAbsoluteUrl(brandLogo)}
                alt='Iglesia Linaje de David'
                className='linaje-brand__logo'
              />
            </a>
            <nav className={`linaje-public-nav ${isMobileMenuOpen ? 'is-open' : ''}`}>
              <button type='button' onClick={() => scrollToSection('home')}>Inicio</button>
              <button type='button' onClick={() => scrollToSection('transmisiones')}>Transmisiones</button>
              <button type='button' onClick={() => scrollToSection('horarios')}>Horarios</button>
              <a href='/material' onClick={() => setIsMobileMenuOpen(false)}>Material</a>
              {/* <a href='/auth' onClick={() => setIsMobileMenuOpen(false)}>Formulario</a> */}
            </nav>
          </div>
        </header>

        <main className='linaje-public-main'>
          <Switch>
            <Route path='/inicio' component={BuilderPageWrapper} />
            <Route path='/auth' component={AuthPage} />
            <Route path='/news' component={Noticias} />
            <Route path='/quienes-somos' component={QuienesSomos} />
            <Route path='/federaciones-y-asociaciones' component={Federaciones} />
            <Route path='/contacto' component={Contacto} />
            <Route path='/material' component={InfoPublica} />
            <Route path='/CIAR' component={CIAR} />
            <Route path='/dia-olimpico' component={DiaOlimpico} />
            <Route path='/memoria-de-labores' component={MemoriaLabores} />
            <Redirect from='/info-publica' to='/material/files' />
            <Redirect from='/informacion-publica' to='/material/files' />
            <Redirect from='/transparencia-presupuestaria' to='/material/transparencia-presupuestaria' />
            <Redirect from='/news' to='/news/public' />
            <Redirect exact from='/' to='/inicio' />
          </Switch>
        </main>

        <footer className='linaje-public-footer'>
          <div className='linaje-public-footer__content'>
            <img
              src={toAbsoluteUrl(brandLogo)}
              alt='Linaje de David'
              className='linaje-public-footer__logo'
            />
           
            <p>Copyright &copy; {new Date().getFullYear()} Iglesia de Cristo Linaje de David.</p>
            <div className='linaje-public-footer__social'>
              <a href='https://www.facebook.com/LinajeDeDavidEbenezerGt' target='_blank' rel='noopener noreferrer'>Facebook</a>
              <a href='https://www.instagram.com/i_linajededavid' target='_blank' rel='noopener noreferrer'>Instagram</a>
              <a href='https://youtube.com/@pastoryevangelistahectordu2744?si=qm_vsvW_I-IHhuA0' target='_blank' rel='noopener noreferrer'>YouTube</a>
            </div>
          </div>
        </footer>
      </div>
    </Suspense>
  )
}
